import { ExternalLink } from 'lucide-react';
import { Favicon } from '@/components/webpage/Favicon';
import type { ChatSource } from '@/lib/chat/types';

interface SourcesListProps {
  sources: ChatSource[];
  onOpenInApp: (source: ChatSource) => void;
}

export function SourcesList({ sources, onOpenInApp }: SourcesListProps) {
  if (sources.length === 0) return null;

  return (
    <div className="mt-4 border-t border-neutral-200 pt-3">
      <p className="mb-2 text-[11px] font-medium uppercase tracking-wider text-neutral-400">Your library</p>
      <div className="flex flex-wrap gap-1.5">
        {sources.map((source, index) => (
          <div
            key={source.webpageId}
            className="group inline-flex items-center gap-1 rounded-full border border-neutral-200 bg-neutral-50 py-1 pl-1 pr-1.5 text-xs text-neutral-700 transition-colors hover:border-neutral-300 hover:bg-white"
          >
            <button
              type="button"
              onClick={() => onOpenInApp(source)}
              className="inline-flex items-center gap-1.5 rounded-full px-0.5"
              title={source.title}
            >
              <Favicon url={source.externalUrl} className="h-3.5 w-3.5 shrink-0" />
              <span className="max-w-[180px] truncate">{source.title}</span>
              <span className="text-[10px] text-neutral-400">[{index + 1}]</span>
            </button>

            <a
              href={source.externalUrl}
              target="_blank"
              rel="noreferrer noopener"
              onClick={event => event.stopPropagation()}
              className="inline-flex h-5 w-5 items-center justify-center rounded-full text-neutral-400 transition-colors hover:bg-neutral-200 hover:text-neutral-600"
              aria-label={`Open ${source.title} externally`}
              title="Open external URL"
            >
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
